import { createSelector } from 'reselect';
import Global from '../store/global-selectors';
import { NonPremiumFeatures } from '../enums/seller-features';
import { Features } from '../constants/features';

const nonPremiumFeatures = Object.values(NonPremiumFeatures);

export const sortPremiumFeatures = (features) => {
  const featureSet = new Set(features);
  const preferredBenefitOrder = [
    Features.ProductBundles,
    Features.ShippingStrategies,
    Features.AutoSplit,
    Features.Cubiscan,
    Features.ODBC,
  ];
  const orderedBenefits = [];
  // Loop through the benefits list add the preferred benefits first
  for (let i = 0; i < preferredBenefitOrder.length; i++) {
    if (featureSet.has(preferredBenefitOrder[i])) {
      orderedBenefits.push(preferredBenefitOrder[i]);
      featureSet.delete(preferredBenefitOrder[i]);
    }
  }
  return [...orderedBenefits, ...featureSet];
};

export const selectOrderedPremiumFeatures = createSelector(Global.selectSellerSellerFeatures, (sellerFeatures) => {
  const filteredFeatures = sellerFeatures.filter((f) => !nonPremiumFeatures.includes(f));
  const sortedFeatures = sortPremiumFeatures(filteredFeatures);
  return sortedFeatures;
});
